import { Avatar as BaseAvatar, Icons, Spinner, styled, theme } from '@arpeggi/ui'

const Root = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '4px'
})

const Card = styled('div', {
  display: 'flex',
  alignItems: 'center',
  borderRadius: 4,
  padding: '4px',
  color: '$gray0500',
  '&:hover': { background: '$whiteA100' },
  '&:focus': { boxShadow: `0 0 0 2px ${theme.colors.whiteA200.value}` }
})

const Avatar = styled(BaseAvatar, {
  width: '32px'
})

const Caret = styled(Icons.CaretDown, {
  marginRight: '-4px'
})

const Loader = styled(Spinner, {
  color: '$white'
})

export const Profile = { Root, Card, Avatar, Caret, Loader }
